// src/theme.js
export const theme = {
  colors: {
    white: '#FFF',
    amber: '#EAB016',
    red: '#F9112C', // danger
    green: '#219A79', // success
    blue: '#1E41FF', // primary
    darkBlue: '#1A0B27',
    mediumBlue: '#1A185D',
    lightGray: '#DBDBDB',
    darkGray: '#868A9C',
    headerPurple: '#20122C',
    darkPurple: '#20112D',
    mediumPurple: '#2A1E38',
    unselectedTab: '#39314A',
    lineColor: '#707070',
    paleBlue: '#4164D8',
    palePurple: '#3A324A',
  },
  borderRadius: '40px',
  buttonVariants: {
    primary: '#1E41FF',  // blue
    secondary: '#EAB016', // amber
    success: '#219A79', // green
    danger: '#F9112C',    // red
    amber: '#EAB016',     // amber
    darkGray: '#868A9C', //darkGray
  },
  fonts: {
    primary: 'basic-sans',
    inter: 'Inter',
  }
};